var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminUserList"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('h4',{staticClass:"font-weight-bold"},[_vm._v("\n        Espace de traduction\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }